import React from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  Box,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useStyles } from "../../campaignModalStyles";
import { i18n } from "../../../../translate/i18n";

const TaggingTabContent = ({
  values,
  setFieldValue,
  touched,
  errors,
  campaignEditable,
  campaignAiChoice,
  tagLists,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid xs={12} item>
      <Paper style={{ padding: 20, backgroundColor: theme.palette.background.paper, marginBottom: 16 }}>
        <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: 16 }}>
          <span role="img" aria-label="Etiquetas">🎯</span> Configuración de ETIQUETAS por Envío de Campañas
        </Typography>

        <Typography
          variant="body2"
          style={{
            marginBottom: 16,
            color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
          }}
        >
          Activa el etiquetado automático para los contactos que reciban y respondan a esta campaña.
          Cuando un contacto responda a los mensajes de la campaña, se le aplicará automáticamente
          la etiqueta que selecciones a continuación. Esto te permitirá identificar fácilmente qué
          contactos interactuaron con esta campaña específica.
        </Typography>

        {campaignAiChoice === "yes" ? (
          <Box mb={2} px={1.5} py={1} style={{ borderRadius: 8, backgroundColor: "rgba(33,150,243,0.09)", display: "flex", alignItems: "flex-start", gap: 10 }}>
            <span role="img" aria-hidden style={{ fontSize: "1.2rem", lineHeight: 1.25, flexShrink: 0 }}>
              🤖
            </span>
            <Typography variant="body2" component="span" style={{ flex: 1 }}>
              {i18n.t("campaigns.dialog.ai.tagMandatoryHint")}
            </Typography>
          </Box>
        ) : null}

        {/* ✅ Checkbox para activar/desactivar etiquetado AUTOMÁTICO (independiente de tagListId) */}
        <FormControlLabel
          control={
            <Checkbox
              checked={campaignAiChoice === "yes" ? true : !!(values.autoTagEnabled || false)}
              onChange={(e) => {
                if (campaignAiChoice === "yes") return;
                setFieldValue('autoTagEnabled', e.target.checked);
                if (!e.target.checked) {
                  setFieldValue('autoTagId', '');
                }
              }}
              disabled={Boolean(!campaignEditable || campaignAiChoice === "yes")}
              color="primary"
            />
          }
          label={
            campaignAiChoice === "yes"
              ? `${i18n.t("campaigns.dialog.ai.autoTagForced")}`
              : (values.autoTagEnabled ? "Activado" : "Desactivado")
          }
          style={{
            marginBottom: 16,
            color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
          }}
        />

        {/* ✅ Mensaje de advertencia si está desactivado */}
        {!values.autoTagEnabled && campaignAiChoice !== "yes" && (
          <Paper
            style={{
              padding: 16,
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              marginBottom: 16,
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <span role="img" aria-label="Advertencia" style={{ fontSize: '20px' }}>⚠️</span>
            <div>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 'bold',
                  marginBottom: 4,
                  color: '#856404' // ✅ Color oscuro para texto en fondo amarillo (modo dark compatible)
                }}
              >
                Etiqueta de Campaña Envío DESACTIVADA
              </Typography>
              <Typography
                variant="body2"
                style={{
                  color: '#856404' // ✅ Color oscuro para texto en fondo amarillo (modo dark compatible)
                }}
              >
                Para activar Etiqueta a Campaña de Envíos, primero activa la detección automática arriba
              </Typography>
            </div>
          </Paper>
        )}

        {/* IA obliga etiqueta: el checkbox muestra "forzado" pero el valor puede quedar sólo en Formik; incluir campaignAiChoice === "yes" */}
        {(campaignAiChoice === "yes" || values.autoTagEnabled) && (
          <Grid xs={12} item style={{ marginTop: 16 }}>
            <Typography
              variant="subtitle2"
              style={{
                marginBottom: 8,
                fontWeight: 'bold',
                color: theme.palette.text.primary // ✅ Color adaptativo para modo dark
              }}
            >
              SI LO ACTIVA REALIZARÁ
            </Typography>
            <FormControl
              variant="outlined"
              margin="dense"
              fullWidth
              className={`${classes.formControl} ${classes.selectField}`}
            >
              <InputLabel id="autoTag-selection-label">
                Seleccione la Etiqueta a vincular
              </InputLabel>
              <Select
                value={values.autoTagId || ""}
                onChange={(e) => setFieldValue('autoTagId', e.target.value || null)}
                disabled={!campaignEditable}
                labelId="autoTag-selection-label"
                label="Seleccione la Etiqueta a vincular"
                error={touched.autoTagId && Boolean(errors.autoTagId)}
              >
                <MenuItem value="">
                  <span role="img" aria-label="No definido">❌</span> No definido
                </MenuItem>
                {Array.isArray(tagLists) &&
                  tagLists.map((tagList) => (
                    <MenuItem key={tagList.id} value={tagList.id}>
                      <span role="img" aria-label="Etiqueta">🏷️</span> {tagList.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Paper>
    </Grid>
  );
};

export default TaggingTabContent;
